import * as React from 'react';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkText } from 'uitk-react-text';

import { ListingSkeleton } from 'components/search/listings';
import { LoadingAnimationSVG } from '.';
import { useStores } from 'utility/hooks';

export const ListingsLoading = observer(() => {
  const { listingsStore, searchFormStore } = useStores();
  const { currentOriginAndDestinationLocationsLabel } = searchFormStore;

  useEffect(
    () => () => {
      listingsStore.shouldShowSkeletons = true;
    },
    [listingsStore.shouldShowSkeletons]
  );

  return !listingsStore.shouldShowSkeletons ? (
    <>
      <UitkSpacing
        className="uitk-type-center"
        padding={{ blockend: 'twelve', large: { blockstart: 'six' }, extra_large: { blockstart: 'six' } }}
      >
        <div>
          <LoadingAnimationSVG height="135.204" />
          <UitkHeading level={2} size={500}>
            {currentOriginAndDestinationLocationsLabel}
          </UitkHeading>
          <UitkText size={300}>{listingsStore.message}</UitkText>
        </div>
      </UitkSpacing>
      <ol className="listings no-bullet">
        {[...Array(listingsStore.listingsSkeletonCount)].map((nullElem, index) => (
          <ListingSkeleton key={`listing-skeleton-${index}`} />
        ))}
      </ol>
    </>
  ) : (
    <ol className="listings no-bullet">
      {[...Array(listingsStore.listingsSkeletonCount)].map((nullElem, index) => (
        <ListingSkeleton key={`listing-skeleton-${index}`} />
      ))}
    </ol>
  );
});
